// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCUiM-fDmPQzMrqWLsd6-RSeN3mdgiFcIs',
    authDomain: 'planet-musicians-dev.firebaseapp.com',
    databaseURL: 'https://planet-musicians-dev.firebaseio.com',
    projectId: 'planet-musicians-dev',
    storageBucket: 'planet-musicians-dev.appspot.com',
    messagingSenderId: '660722608436'
  },
  algolia: {
    applicationId: '67INFKZOBY',
    apiKey: '497b8c2013326107a3e30e0fdd2e1c47'
  }
};
